import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'pxw-icon[icon="cash-register"]',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['../icon/icon.component.scss'],
  providers: [{ provide: IconComponent, useExisting: IconCashRegisterComponent }],
  template: `<svg viewBox="0 0 45 46" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      d="M6.9 8H38.1Q40.5 8 40.5 10.4V14.1Q40.5 16.5 38.1 16.5H6.9Q4.5 16.5 4.5 14.1V10.4Q4.5 8 6.9 8ZM7.9 10.6H37.1Q37.9 10.6 37.9 11.4V13.1Q37.9 13.9 37.1 13.9H7.9Q7.1 13.9 7.1 13.1V11.4Q7.1 10.6 7.9 10.6ZM10.1 16.5H34.9Q37.5 16.5 37.5 19.1V35.4Q37.5 38 34.9 38H10.1Q7.5 38 7.5 35.4V19.1Q7.5 16.5 10.1 16.5ZM10.9 19.1H34.1Q34.9 19.1 34.9 19.9V34.6Q34.9 35.4 34.1 35.4H10.9Q10.1 35.4 10.1 34.6V19.9Q10.1 19.1 10.9 19.1ZM19.1 23H25.9Q27.5 23 27.5 24.6Q27.5 26.2 25.9 26.2H19.1Q17.5 26.2 17.5 24.6Q17.5 23 19.1 23Z"
    />
  </svg>`,
})
export class IconCashRegisterComponent extends IconComponent {}
